// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3to-f","actionsCol":"EnrolledClinics_actionsCol__2a6mt"};